export const getSummary = (summary, summaryCommons) => {
  let summaryCommon = Object.assign(
    {
      membership: null,
      country: null,
      engine: null,
      color: null,
      deposit: null,
      price: null,
      currency: null,
      shopspuId: null
    },
    summaryCommons
  );
  let summaryData = {};
  if (summary && summary.fields) {
    let { headingBody, headingType, body, membershipSectionName, countryLabel, membership, carselectionName, colorLabel, engineLabel, topaynowSectionName, preorderdeposit, price, disclaimer } = summary.fields;
    // let image1 = null;
    // console.log(summaryCommon,"summ")
    // if (summaryCommon.color && summaryCommon.color.options) {
    //   image1 = {};
    //   summaryCommon.color.options.forEach(item => {
    //     image1[item.value] = [
    //       {
    //         type: "image",
    //         src: item.image,
    //         alt: "",
    //         title: ""
    //       }
    //     ];
    //   });
    // }
    summaryData = {
      showCarSelection: !!(summaryCommon.color && summaryCommon.color.options && summaryCommon.color.preSelectValue && summaryCommon.engine && summaryCommon.engine.options && summaryCommon.engine.preSelectValue),
      text: {
        heading: {
          type: headingType || {
            fields: { phrase: { value: "h3" } }
          },
          html: headingBody
        },
        body: body && body.value
      },
      // images: image1,
      selectedColor: summaryCommon.color && summaryCommon.color.preSelectValue && summaryCommon.color.preSelectValue.value,
      details: {
        componentPadding: { top: 0, bottom: 0 },
        // carModel: "01",
        membership: {
          heading: {
            type: { fields: { phrase: { value: "" } } },
            html: {
              value: `<span class="sub-heading">${membershipSectionName ? membershipSectionName.value : ""}</span>`
            }
          },
          country: {
            label: countryLabel ? countryLabel.value : "",
            value: summaryCommon.country || ""
          },
          membership: {
            label: membership ? membership.value : "",
            value: summaryCommon.membership || ""
          }
        },
        selection: {
          heading: {
            type: { fields: { phrase: { value: "" } } },
            html: {
              value: `<span class="sub-heading">${carselectionName ? carselectionName.value : ""}</span>`
            }
          },
          choices: {
            color: {
              label: colorLabel ? colorLabel.value : "",
              selected: summaryCommon.color && summaryCommon.color.preSelectValue,
              options: summaryCommon.color && summaryCommon.color.options
            },
            engine: {
              label: engineLabel ? engineLabel.value : "",
              selected: summaryCommon.engine && summaryCommon.engine.preSelectValue,
              options: summaryCommon.engine && summaryCommon.engine.options
            }
          }
        },
        deposit: {
          heading: {
            type: { fields: { phrase: { value: "" } } },
            html: {
              value: `<span class="sub-heading">${topaynowSectionName ? topaynowSectionName.value : ""}</span>`
            }
          },
          deposit: {
            label: preorderdeposit ? preorderdeposit.value : "",
            value: summaryCommon.formattedPrice || 0
          },
          currency: summaryCommon.currency || "",
          disclaimer: {
            body: disclaimer ? disclaimer.value : ""
          }
        },
        price: {
          label: price?.value ? price.value : "",
          value: summaryCommon.formattedMsrp || 0
        }
      }
    };
  }
  return summaryData;
};
